module.exports = __webpack_public_path__ + "static/media/mobM.3488755a.png";